import { render, staticRenderFns } from "./google-get-folder-input.vue?vue&type=template&id=5836f551&scoped=true"
import script from "./google-get-folder-input.vue?vue&type=script&lang=js"
export * from "./google-get-folder-input.vue?vue&type=script&lang=js"
import style0 from "./google-get-folder-input.vue?vue&type=style&index=0&id=5836f551&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5836f551",
  null
  
)

export default component.exports